import { render, staticRenderFns } from "./reservation-notifications.vue?vue&type=template&id=af98549e&"
import script from "./reservation-notifications.vue?vue&type=script&lang=js&"
export * from "./reservation-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports